function toggleTable(unit) {
  const tables = ['inches-table', 'cm-table', 'howToMeasure-table'];
  const sizeChartContainer = document.querySelector('.table_sizechart-container');
  if (!sizeChartContainer) {
      return; // Return early if size chart container is not found
  }

  tables.forEach(tableName => {
      const tableElement = document.querySelector(`.${tableName}`);
      if (tableElement) tableElement.classList.add('hidden');
  });

  document.querySelectorAll('.table_sizechart-container .tab').forEach(tab => tab.classList.remove('active'));

  const selectedTable = document.querySelector(`.${unit}-table`);
  if (selectedTable) {
      selectedTable.classList.remove('hidden');
      selectedTable.setAttribute('aria-selected', 'true'); // Update ARIA selection
      selectedTable.setAttribute('aria-hidden', 'false');  // Make visible to screen readers
      selectedTable.setAttribute('role', 'table');          // Proper role for active table
  }

  document.querySelector(`.table_sizechart-container [onclick="toggleTable('${unit}')"]`)?.classList.add('active');

  const externalXAxisLabel = document.getElementById('externalXAxisLabel');
  const externalYAxisLabel = document.getElementById('externalYAxisLabel');
  if (unit === 'howToMeasure' && externalXAxisLabel && externalYAxisLabel) {
      externalXAxisLabel.style.display = 'none';
      externalYAxisLabel.style.display = 'none';
  } else if (externalXAxisLabel && externalYAxisLabel) {
      externalXAxisLabel.style.display = 'block';
      externalYAxisLabel.style.display = 'block';
      if (externalXAxisLabel.textContent.trim() && externalYAxisLabel.textContent.trim()) {
          selectedTable.style.paddingTop = '20px';
      }
  }
}

function hideFirstRowIfUnit(tableSelector) {
  const table = document.querySelector(tableSelector);
  if (table) {
      table.setAttribute('tabindex', '0'); // Make tabs focusable
      const firstRow = table.querySelector('tbody tr:first-child');
      if (firstRow) {
          const cells = Array.from(firstRow.querySelectorAll('td'));
          const allIN = cells.every(cell => cell.textContent.trim() === 'IN');
          const allCM = cells.every(cell => cell.textContent.trim() === 'CM');
          if (allIN || allCM) {
              firstRow.style.display = 'none';
          }
      }
  }
}

function isMobileDevice() {
  return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
}

// Step 2: Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  hideFirstRowIfUnit('.inches-table');
  hideFirstRowIfUnit('.cm-table');
  toggleTable('inches'); // Or based on some condition from your page

  const tabs = document.querySelectorAll('.table_sizechart-tabs .tab');
  tabs.forEach(tab => {
      tab.setAttribute('tabindex', '0'); // Make tabs focusable
      if (tab.textContent.trim() === 'Cms') {
          tab.textContent = 'Centimeters';
      }
      tab.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
              const unit = this.getAttribute('data-unit'); // Ensure the unit is defined before passing
              toggleTable(unit);
              e.preventDefault(); // Prevent default to avoid scrolling on space key
          }
      });
  });

  const howToMeasureImg = document.querySelector('.howToMeasure-table img');
  if (howToMeasureImg && !howToMeasureImg.getAttribute('src')) {
      const howToMeasureTab = document.querySelector('.table_sizechart-tabs .tab[data-unit="howToMeasure"]');
      if (howToMeasureTab) {
          howToMeasureTab.style.display = 'none';
      }
  }

  const activeTab = document.querySelector('.table_sizechart-tabs .tab[data-unit="inches"]'); // Ensure unit is defined
  if (activeTab) {
      activeTab.classList.add('active');
      activeTab.setAttribute('aria-selected', 'true');
  }

  if (isMobileDevice()) {
      const tableWrapped = document.querySelector(".table_sizechart-container");
      const tableWrappedBody = document.querySelector(".table_sizechart-container tbody");
      if (tableWrapped) {
          // Create and configure the scroll-bar div
          const scrollBarDiv = document.createElement("div");
          scrollBarDiv.className = "scroll-bar";
          scrollBarDiv.id = "scrollIndicator";
          scrollBarDiv.innerHTML = '<span>Scroll for more</span><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg" ><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"> </svg>';
          scrollBarDiv.style.display = 'none'; // Hide by default
          tableWrapped.appendChild(scrollBarDiv);

          // Function to update scroll indicator visibility based on overflow
          function updateScrollIndicatorVisibility() {
              if (tableWrapped.scrollWidth < tableWrappedBody.clientWidth) {
                  scrollBarDiv.style.display = 'block';
              } else {
                  scrollBarDiv.style.display = 'none';
              }
          }

          // Check and update on load
          updateScrollIndicatorVisibility();

          // Handle touch move
          tableWrapped.addEventListener("touchmove", function(e) {
              const currentTouchX = e.touches[0].clientX;
              const deltaX = currentTouchX - initialTouchX;
              const scrollDirection = deltaX > 0 ? 'left' : 'right';
              this.scrollLeft -= deltaX;
              initialTouchX = currentTouchX;
              const maxScrollLeft = this.scrollWidth - this.clientWidth;
              if (this.scrollLeft >= maxScrollLeft && scrollDirection === 'right') {
                  arrowSvg.style.transform = "rotate(180deg)";
              } else if (this.scrollLeft <= 0 && scrollDirection === 'left') {
                  arrowSvg.style.transform = "rotate(0deg)";
              }
          });

          // Handle touch end
          tableWrapped.addEventListener("touchend", function() {
              // Optional: Add functionality here for when touch movement ends
          });
      }

      const activeTab = document.querySelector('.table_sizechart-tabs .tab[data-unit="inches"]');
      if (activeTab) {
          activeTab.classList.add('active');
          activeTab.setAttribute('aria-selected', 'true'); // Accessibility improvement
      }
  }
});

function updateAccessibilityLabels(table) {
  if (!table) return; // Ensuring each cell in the table has appropriate labels
  const cells = table.querySelectorAll('td');
  cells.forEach(cell => {
      const headerText = cell.getAttribute('data-label') || 'Detail';
      cell.setAttribute('role', 'cell');
      cell.setAttribute('aria-label', headerText);
  });
}

// Setting up initial data-unit attributes
document.querySelector('.tab[onclick="toggleTable(\'inches\')"]').setAttribute('data-unit', 'inches');
document.querySelector('.tab[onclick="toggleTable(\'cm\')"]').setAttribute('data-unit', 'cm');
document.querySelector('.tab[onclick="toggleTable(\'howToMeasure\')"]').setAttribute('data-unit', 'howToMeasure');